import DefaultView from 'nette-front-module/js/views/front.default'
import merge from 'lodash/merge'

export default merge({
  data () {
    return {
    }
  },
  computed: {
    searchTags () {
      const tags = {}
      let cnt = 0

      for (let i = 0; i < this.$controls.searchTags.results.length; i++) {
        const result = this.$controls.searchTags.results[i];
        for (let ii = 0; ii < result.row.tags.length; ii++) {
          const tag = result.row.tags[ii];
          
          if (!tags[tag.id]) {
            tags[tag.id] = tag
            cnt++
            if (cnt === 10) {
              break
            }
          }
        }
        if (cnt === 10) {
          break
        }
      }

      return tags
    }
  },
  mounted () {
    
  },
}, DefaultView)
